import styled from "styled-components";
import { RATypography } from "@/components/customs";

export function CharterDetailAircraftCategory({ aircraftCategories = [], type, aircraft = {} }) {
	const getGroupNameCategories = () => {
		return aircraftCategories?.map((v) => v.name).join(", ");
	};
	return (
		<Container>
			<RATypography variant="body4" color="#595959">
				{type === "EMPTY_LEG" ? "Aircraft" : "Aircraft Category"}
			</RATypography>
			<RATypography variant="sub-heading4">
				{type === "EMPTY_LEG" ? `${aircraft?.name} - ${aircraft?.tail_number}` : getGroupNameCategories()}
			</RATypography>
		</Container>
	);
}

const Container = styled.div`
	height: 100%;
	background: #ffffff;
	border-radius: 0px 0px 0px 8px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	border-top: 1px solid #e9e8e8;
	border-right: 1px solid #e9e8e8;
	padding: 10px 20px;
	gap: 6px;
	@media (max-width: 1024px) {
		padding: 10px 16px;
	}
	@media (max-width: 768px) {
		flex-direction: row;
		justify-content: flex-start;
		align-items: center;
		padding: 12px 16px;
		border-radius: 0;
		border: none;
		border-bottom: 1px solid #e9e8e8;
	}
`;
